$(document).ready(function(){
  var hided = setInterval(function () {
    if ($(".cart__total-price-info")[0]){
      $('.cart__total-price-info .col-6').each(function(i){
        $(this).addClass('uniqueName' + i);
      });
      if ($(".uniqueName1")[0]){
        clearInterval(hided);
      }
    }
  }, 1000);

  /* remove handler for customised items is in cart_drawer.js (capture phase) */
});

// Calculate the progress number, and the width of the progress bar.
function calculateProgress(currentVal, targetVal) {
  var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
  var progressNum = document.querySelectorAll('.cart-shipping__num');
  var progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
  var successMsg = document.querySelectorAll('.cart-shipping__success');
  var free_shipping_textfree = document.querySelectorAll('.free_shipping_textfree');
  var result = Math.round(100 * currentVal / targetVal);
  progressBar.forEach(function(el){
    el.setAttribute('style', "width: ".concat(result, "%"));
  });
  var newProgressNum = (targetVal - currentVal) / 100;
  if(newProgressNum <= 0){
    successMsg.forEach(function(el){ el.style.display = 'block'; });
    progressOuter.forEach(function(el){ el.style.display = 'none'; });
    progressNum.forEach(function(el){ el.textContent = newProgressNum; });
    $('.free_shipping_text').css('display','none');
    $('.free_shipping_textfree').css('display','block');
  } else {
    successMsg.forEach(function(el){ el.style.display = 'none'; });
    progressOuter.forEach(function(el){ el.style.display = 'block'; });
    progressNum.forEach(function(el){ el.textContent = newProgressNum; });
    var remaining = '$' + Math.ceil(newProgressNum);
    $('.free_shipping_text').html("ADD <strong>" + remaining + "</strong> TO GET FREE SHIPPING").css('display','block');
    $('.free_shipping_textfree').css('display','none');
  }
}

/* Removed 18 Aug 2026: a 1s setInterval polled /cart.js forever on every page
   to feed calculateProgress. Its only remaining target, .free_shipping_text,
   sits inside .pdpfree_shipping_bar which custom_product_customize.css hides
   with display:none !important; .cstm_outershipping is rendered nowhere, so
   the .freeshipping copy was a no-op. The cart drawer (cart_drawer.js) owns
   all live progress UI, event-driven. calculateProgress stays defined below
   in case an app embed references it. */

document.addEventListener("change", function(e) {
  if (!e.target.classList.contains("othervariants")) return;
  const selectedOption = e.target.options[e.target.selectedIndex];
  const dataId = selectedOption.getAttribute("data-id");
  const variantId = parseInt(dataId);
  $('.product_details .variant_id').attr('data-variant', variantId);
});
